import { useGraphQLQuery } from '@betterment/graphql';

import { FourOhOneKContributionsQueryResult } from './data';
import {
  FourOhOneKContributionsDocument,
  FourOhOneKContributionsQuery,
  FourOhOneKContributionsQueryVariables,
} from './graphql/query.fourOhOneKContributions.generated';

export const useFourOhOneKContributionsQuery = (
  householdId: string,
  accountId: string
): FourOhOneKContributionsQueryResult => {
  const { data, loading: isLoading } = useGraphQLQuery<
    FourOhOneKContributionsQuery,
    FourOhOneKContributionsQueryVariables
  >(FourOhOneKContributionsDocument, {
    variables: {
      householdId,
      accountId,
    },
    throwOnError: true,
  });

  const filteredContributionData = data?.household?.members?.find(member =>
    data?.envelopeAccount?.accountHolders?.some(holder => holder.id === member.id)
  );

  return {
    isLoading,
    employeeContributions: filteredContributionData?.fourOhOneKContributions,
    employers: filteredContributionData?.employers,
    clientId: filteredContributionData?.id,
  };
};
